"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../utils/helpers");
var styles_1 = require("./styles");
function BoxedIcon(_a) {
    var type = _a.type, icon = _a.icon;
    var mainStyles = helpers_1.getStyledComponentMainStyles(type);
    return react_1.default.createElement(styles_1.MainContainer, { style: mainStyles }, icon);
}
exports.default = BoxedIcon;
//# sourceMappingURL=index.js.map